import { render, staticRenderFns } from "./VSuggestContact.vue?vue&type=template&id=55e506cb"
import script from "./VSuggestContact.vue?vue&type=script&lang=js"
export * from "./VSuggestContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports